import axiosClient from "./axiosClient";

export const getCauses = async (userId) => {
  const response = await axiosClient.get("/cause", {
    params: {
      userId,
    },
  });

  return response.data;
};

export const getTeamCauses = async (teamId, period) => {
  const response = await axiosClient.get("/teamcause", {
    params: {
      teamId: teamId,
      period: period
    },
  });

  return response.data;
};

export const addCause = async ({ causeTypeId, userId, feelingId, name, teamId }) => {
  const response = await axiosClient.post("/cause", {
    causeTypeId,
    userId,
    feelingId,
    name,
    teamId
  });

  return response.data;
};